module.exports = __webpack_public_path__ + "assets/img/zgyz.e23e9142.png";